// Generated by purs version 0.14.3
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Eq_Generic = require("../Data.Eq.Generic/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Show_Generic = require("../Data.Show.Generic/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Tuple9 = (function () {
    function Tuple9(value0, value1, value2, value3, value4, value5, value6, value7, value8) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
    };
    Tuple9.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return new Tuple9(value0, value1, value2, value3, value4, value5, value6, value7, value8);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple9;
})();
var Tuple8 = (function () {
    function Tuple8(value0, value1, value2, value3, value4, value5, value6, value7) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
    };
    Tuple8.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return new Tuple8(value0, value1, value2, value3, value4, value5, value6, value7);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple8;
})();
var Tuple7 = (function () {
    function Tuple7(value0, value1, value2, value3, value4, value5, value6) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
    };
    Tuple7.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return new Tuple7(value0, value1, value2, value3, value4, value5, value6);
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple7;
})();
var Tuple6 = (function () {
    function Tuple6(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    };
    Tuple6.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return new Tuple6(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return Tuple6;
})();
var Tuple5 = (function () {
    function Tuple5(value0, value1, value2, value3, value4) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
    };
    Tuple5.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return new Tuple5(value0, value1, value2, value3, value4);
                    };
                };
            };
        };
    };
    return Tuple5;
})();
var Tuple4 = (function () {
    function Tuple4(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    Tuple4.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new Tuple4(value0, value1, value2, value3);
                };
            };
        };
    };
    return Tuple4;
})();
var Tuple3 = (function () {
    function Tuple3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Tuple3.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Tuple3(value0, value1, value2);
            };
        };
    };
    return Tuple3;
})();
var Tuple2 = (function () {
    function Tuple2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Tuple2.create = function (value0) {
        return function (value1) {
            return new Tuple2(value0, value1);
        };
    };
    return Tuple2;
})();
var Tuple16 = (function () {
    function Tuple16(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13, value14, value15) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
        this.value9 = value9;
        this.value10 = value10;
        this.value11 = value11;
        this.value12 = value12;
        this.value13 = value13;
        this.value14 = value14;
        this.value15 = value15;
    };
    Tuple16.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return function (value9) {
                                            return function (value10) {
                                                return function (value11) {
                                                    return function (value12) {
                                                        return function (value13) {
                                                            return function (value14) {
                                                                return function (value15) {
                                                                    return new Tuple16(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13, value14, value15);
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple16;
})();
var Tuple15 = (function () {
    function Tuple15(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13, value14) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
        this.value9 = value9;
        this.value10 = value10;
        this.value11 = value11;
        this.value12 = value12;
        this.value13 = value13;
        this.value14 = value14;
    };
    Tuple15.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return function (value9) {
                                            return function (value10) {
                                                return function (value11) {
                                                    return function (value12) {
                                                        return function (value13) {
                                                            return function (value14) {
                                                                return new Tuple15(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13, value14);
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple15;
})();
var Tuple14 = (function () {
    function Tuple14(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
        this.value9 = value9;
        this.value10 = value10;
        this.value11 = value11;
        this.value12 = value12;
        this.value13 = value13;
    };
    Tuple14.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return function (value9) {
                                            return function (value10) {
                                                return function (value11) {
                                                    return function (value12) {
                                                        return function (value13) {
                                                            return new Tuple14(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12, value13);
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple14;
})();
var Tuple13 = (function () {
    function Tuple13(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
        this.value9 = value9;
        this.value10 = value10;
        this.value11 = value11;
        this.value12 = value12;
    };
    Tuple13.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return function (value9) {
                                            return function (value10) {
                                                return function (value11) {
                                                    return function (value12) {
                                                        return new Tuple13(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12);
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple13;
})();
var Tuple12 = (function () {
    function Tuple12(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
        this.value9 = value9;
        this.value10 = value10;
        this.value11 = value11;
    };
    Tuple12.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return function (value9) {
                                            return function (value10) {
                                                return function (value11) {
                                                    return new Tuple12(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11);
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple12;
})();
var Tuple11 = (function () {
    function Tuple11(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
        this.value9 = value9;
        this.value10 = value10;
    };
    Tuple11.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return function (value9) {
                                            return function (value10) {
                                                return new Tuple11(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9, value10);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple11;
})();
var Tuple10 = (function () {
    function Tuple10(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
        this.value8 = value8;
        this.value9 = value9;
    };
    Tuple10.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return function (value8) {
                                        return function (value9) {
                                            return new Tuple10(value0, value1, value2, value3, value4, value5, value6, value7, value8, value9);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Tuple10;
})();
var Tuple1 = function (x) {
    return x;
};
var Tuple0 = (function () {
    function Tuple0() {

    };
    Tuple0.value = new Tuple0();
    return Tuple0;
})();
var uncurry9 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8);
    };
};
var uncurry8 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7);
    };
};
var uncurry7 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6);
    };
};
var uncurry6 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5);
    };
};
var uncurry5 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4);
    };
};
var uncurry4 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3);
    };
};
var uncurry3 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2);
    };
};
var uncurry2 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1);
    };
};
var uncurry16 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8)(v.value9)(v.value10)(v.value11)(v.value12)(v.value13)(v.value14)(v.value15);
    };
};
var uncurry15 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8)(v.value9)(v.value10)(v.value11)(v.value12)(v.value13)(v.value14);
    };
};
var uncurry14 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8)(v.value9)(v.value10)(v.value11)(v.value12)(v.value13);
    };
};
var uncurry13 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8)(v.value9)(v.value10)(v.value11)(v.value12);
    };
};
var uncurry12 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8)(v.value9)(v.value10)(v.value11);
    };
};
var uncurry11 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8)(v.value9)(v.value10);
    };
};
var uncurry10 = function (fun) {
    return function (v) {
        return fun(v.value0)(v.value1)(v.value2)(v.value3)(v.value4)(v.value5)(v.value6)(v.value7)(v.value8)(v.value9);
    };
};
var uncurry1 = function (fun) {
    return function (v) {
        return fun(v);
    };
};
var unTuple1 = function (v) {
    return v;
};
var showTupleO = new Data_Show.Show(function (v) {
    return "Tuple0";
});
var genericTuple9 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, x.value8))))))));
}, function (x) {
    return new Tuple9(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple9 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple9)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsArgument(dictShow8))))))))))(new Data_Symbol.IsSymbol(function () {
                                        return "Tuple9";
                                    }))));
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple8 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, x.value7)))))));
}, function (x) {
    return new Tuple8(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple8 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple8)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsArgument(dictShow7)))))))))(new Data_Symbol.IsSymbol(function () {
                                    return "Tuple8";
                                }))));
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple7 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, x.value6))))));
}, function (x) {
    return new Tuple7(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1);
});
var showTuple7 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple7)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsArgument(dictShow6))))))))(new Data_Symbol.IsSymbol(function () {
                                return "Tuple7";
                            }))));
                        };
                    };
                };
            };
        };
    };
};
var genericTuple6 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, x.value5)))));
}, function (x) {
    return new Tuple6(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1);
});
var showTuple6 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple6)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsArgument(dictShow5)))))))(new Data_Symbol.IsSymbol(function () {
                            return "Tuple6";
                        }))));
                    };
                };
            };
        };
    };
};
var genericTuple5 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, x.value4))));
}, function (x) {
    return new Tuple5(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1);
});
var showTuple5 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple5)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsArgument(dictShow4))))))(new Data_Symbol.IsSymbol(function () {
                        return "Tuple5";
                    }))));
                };
            };
        };
    };
};
var genericTuple4 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, x.value3)));
}, function (x) {
    return new Tuple4(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1);
});
var showTuple4 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple4)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsArgument(dictShow3)))))(new Data_Symbol.IsSymbol(function () {
                    return "Tuple4";
                }))));
            };
        };
    };
};
var genericTuple3 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2));
}, function (x) {
    return new Tuple3(x.value0, x.value1.value0, x.value1.value1);
});
var showTuple3 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple3)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsArgument(dictShow2))))(new Data_Symbol.IsSymbol(function () {
                return "Tuple3";
            }))));
        };
    };
};
var genericTuple2 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, x.value1);
}, function (x) {
    return new Tuple2(x.value0, x.value1);
});
var showTuple2 = function (dictShow) {
    return function (dictShow1) {
        return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple2)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsArgument(dictShow1)))(new Data_Symbol.IsSymbol(function () {
            return "Tuple2";
        }))));
    };
};
var genericTuple16 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, new Data_Generic_Rep.Product(x.value8, new Data_Generic_Rep.Product(x.value9, new Data_Generic_Rep.Product(x.value10, new Data_Generic_Rep.Product(x.value11, new Data_Generic_Rep.Product(x.value12, new Data_Generic_Rep.Product(x.value13, new Data_Generic_Rep.Product(x.value14, x.value15)))))))))))))));
}, function (x) {
    return new Tuple16(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple16 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return function (dictShow9) {
                                        return function (dictShow10) {
                                            return function (dictShow11) {
                                                return function (dictShow12) {
                                                    return function (dictShow13) {
                                                        return function (dictShow14) {
                                                            return function (dictShow15) {
                                                                return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple16)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow8))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow9))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow10))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow11))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow12))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow13))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow14))(Data_Show_Generic.genericShowArgsArgument(dictShow15)))))))))))))))))(new Data_Symbol.IsSymbol(function () {
                                                                    return "Tuple16";
                                                                }))));
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple15 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, new Data_Generic_Rep.Product(x.value8, new Data_Generic_Rep.Product(x.value9, new Data_Generic_Rep.Product(x.value10, new Data_Generic_Rep.Product(x.value11, new Data_Generic_Rep.Product(x.value12, new Data_Generic_Rep.Product(x.value13, x.value14))))))))))))));
}, function (x) {
    return new Tuple15(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple15 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return function (dictShow9) {
                                        return function (dictShow10) {
                                            return function (dictShow11) {
                                                return function (dictShow12) {
                                                    return function (dictShow13) {
                                                        return function (dictShow14) {
                                                            return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple15)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow8))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow9))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow10))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow11))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow12))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow13))(Data_Show_Generic.genericShowArgsArgument(dictShow14))))))))))))))))(new Data_Symbol.IsSymbol(function () {
                                                                return "Tuple15";
                                                            }))));
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple14 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, new Data_Generic_Rep.Product(x.value8, new Data_Generic_Rep.Product(x.value9, new Data_Generic_Rep.Product(x.value10, new Data_Generic_Rep.Product(x.value11, new Data_Generic_Rep.Product(x.value12, x.value13)))))))))))));
}, function (x) {
    return new Tuple14(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple14 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return function (dictShow9) {
                                        return function (dictShow10) {
                                            return function (dictShow11) {
                                                return function (dictShow12) {
                                                    return function (dictShow13) {
                                                        return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple14)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow8))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow9))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow10))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow11))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow12))(Data_Show_Generic.genericShowArgsArgument(dictShow13)))))))))))))))(new Data_Symbol.IsSymbol(function () {
                                                            return "Tuple14";
                                                        }))));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple13 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, new Data_Generic_Rep.Product(x.value8, new Data_Generic_Rep.Product(x.value9, new Data_Generic_Rep.Product(x.value10, new Data_Generic_Rep.Product(x.value11, x.value12))))))))))));
}, function (x) {
    return new Tuple13(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple13 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return function (dictShow9) {
                                        return function (dictShow10) {
                                            return function (dictShow11) {
                                                return function (dictShow12) {
                                                    return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple13)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow8))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow9))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow10))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow11))(Data_Show_Generic.genericShowArgsArgument(dictShow12))))))))))))))(new Data_Symbol.IsSymbol(function () {
                                                        return "Tuple13";
                                                    }))));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple12 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, new Data_Generic_Rep.Product(x.value8, new Data_Generic_Rep.Product(x.value9, new Data_Generic_Rep.Product(x.value10, x.value11)))))))))));
}, function (x) {
    return new Tuple12(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple12 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return function (dictShow9) {
                                        return function (dictShow10) {
                                            return function (dictShow11) {
                                                return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple12)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow8))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow9))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow10))(Data_Show_Generic.genericShowArgsArgument(dictShow11)))))))))))))(new Data_Symbol.IsSymbol(function () {
                                                    return "Tuple12";
                                                }))));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple11 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, new Data_Generic_Rep.Product(x.value8, new Data_Generic_Rep.Product(x.value9, x.value10))))))))));
}, function (x) {
    return new Tuple11(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple11 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return function (dictShow9) {
                                        return function (dictShow10) {
                                            return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple11)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow8))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow9))(Data_Show_Generic.genericShowArgsArgument(dictShow10))))))))))))(new Data_Symbol.IsSymbol(function () {
                                                return "Tuple11";
                                            }))));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple10 = new Data_Generic_Rep.Generic(function (x) {
    return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, new Data_Generic_Rep.Product(x.value2, new Data_Generic_Rep.Product(x.value3, new Data_Generic_Rep.Product(x.value4, new Data_Generic_Rep.Product(x.value5, new Data_Generic_Rep.Product(x.value6, new Data_Generic_Rep.Product(x.value7, new Data_Generic_Rep.Product(x.value8, x.value9)))))))));
}, function (x) {
    return new Tuple10(x.value0, x.value1.value0, x.value1.value1.value0, x.value1.value1.value1.value0, x.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value0, x.value1.value1.value1.value1.value1.value1.value1.value1.value1);
});
var showTuple10 = function (dictShow) {
    return function (dictShow1) {
        return function (dictShow2) {
            return function (dictShow3) {
                return function (dictShow4) {
                    return function (dictShow5) {
                        return function (dictShow6) {
                            return function (dictShow7) {
                                return function (dictShow8) {
                                    return function (dictShow9) {
                                        return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple10)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow1))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow2))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow3))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow4))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow5))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow6))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow7))(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow8))(Data_Show_Generic.genericShowArgsArgument(dictShow9)))))))))))(new Data_Symbol.IsSymbol(function () {
                                            return "Tuple10";
                                        }))));
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var genericTuple1 = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showTuple1 = function (dictShow) {
    return new Data_Show.Show(Data_Show_Generic.genericShow(genericTuple1)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
        return "Tuple1";
    }))));
};
var genericTuple0 = new Data_Generic_Rep.Generic(function (x) {
    return Data_Generic_Rep.NoArguments.value;
}, function (x) {
    return Tuple0.value;
});
var eqTuple9 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple9)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqArgument(dictEq8))))))))))));
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple8 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple8)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqArgument(dictEq7)))))))))));
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple7 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple7)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqArgument(dictEq6))))))))));
                        };
                    };
                };
            };
        };
    };
};
var eqTuple6 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple6)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqArgument(dictEq5)))))))));
                    };
                };
            };
        };
    };
};
var eqTuple5 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple5)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqArgument(dictEq4))))))));
                };
            };
        };
    };
};
var eqTuple4 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple4)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqArgument(dictEq3)))))));
            };
        };
    };
};
var eqTuple3 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple3)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqArgument(dictEq2))))));
        };
    };
};
var eqTuple2 = function (dictEq) {
    return function (dictEq1) {
        return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple2)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqArgument(dictEq1)))));
    };
};
var eqTuple16 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return function (dictEq9) {
                                        return function (dictEq10) {
                                            return function (dictEq11) {
                                                return function (dictEq12) {
                                                    return function (dictEq13) {
                                                        return function (dictEq14) {
                                                            return function (dictEq15) {
                                                                return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple16)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq8))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq9))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq10))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq11))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq12))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq13))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq14))(Data_Eq_Generic.genericEqArgument(dictEq15)))))))))))))))))));
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple15 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return function (dictEq9) {
                                        return function (dictEq10) {
                                            return function (dictEq11) {
                                                return function (dictEq12) {
                                                    return function (dictEq13) {
                                                        return function (dictEq14) {
                                                            return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple15)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq8))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq9))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq10))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq11))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq12))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq13))(Data_Eq_Generic.genericEqArgument(dictEq14))))))))))))))))));
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple14 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return function (dictEq9) {
                                        return function (dictEq10) {
                                            return function (dictEq11) {
                                                return function (dictEq12) {
                                                    return function (dictEq13) {
                                                        return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple14)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq8))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq9))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq10))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq11))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq12))(Data_Eq_Generic.genericEqArgument(dictEq13)))))))))))))))));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple13 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return function (dictEq9) {
                                        return function (dictEq10) {
                                            return function (dictEq11) {
                                                return function (dictEq12) {
                                                    return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple13)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq8))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq9))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq10))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq11))(Data_Eq_Generic.genericEqArgument(dictEq12))))))))))))))));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple12 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return function (dictEq9) {
                                        return function (dictEq10) {
                                            return function (dictEq11) {
                                                return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple12)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq8))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq9))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq10))(Data_Eq_Generic.genericEqArgument(dictEq11)))))))))))))));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple11 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return function (dictEq9) {
                                        return function (dictEq10) {
                                            return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple11)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq8))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq9))(Data_Eq_Generic.genericEqArgument(dictEq10))))))))))))));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple10 = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return function (dictEq3) {
                return function (dictEq4) {
                    return function (dictEq5) {
                        return function (dictEq6) {
                            return function (dictEq7) {
                                return function (dictEq8) {
                                    return function (dictEq9) {
                                        return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple10)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq1))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq2))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq3))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq4))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq5))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq6))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq7))(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(dictEq8))(Data_Eq_Generic.genericEqArgument(dictEq9)))))))))))));
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqTuple1 = function (dictEq) {
    return new Data_Eq.Eq(Data_Eq_Generic.genericEq(genericTuple1)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(dictEq))));
};
var eqTuple0 = new Data_Eq.Eq(function (v) {
    return function (v1) {
        return true;
    };
});
var curry9 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return fun(new Tuple9(a, b, c, d, e, f, g, h, i));
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry8 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return fun(new Tuple8(a, b, c, d, e, f, g, h));
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry7 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return fun(new Tuple7(a, b, c, d, e, f, g));
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry6 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return fun(new Tuple6(a, b, c, d, e, f));
                        };
                    };
                };
            };
        };
    };
};
var curry5 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return fun(new Tuple5(a, b, c, d, e));
                    };
                };
            };
        };
    };
};
var curry4 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return fun(new Tuple4(a, b, c, d));
                };
            };
        };
    };
};
var curry3 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return fun(new Tuple3(a, b, c));
            };
        };
    };
};
var curry2 = function (fun) {
    return function (a) {
        return function (b) {
            return fun(new Tuple2(a, b));
        };
    };
};
var curry16 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return function (j) {
                                            return function (k) {
                                                return function (l) {
                                                    return function (m) {
                                                        return function (n) {
                                                            return function (o) {
                                                                return function (p) {
                                                                    return fun(new Tuple16(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p));
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry15 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return function (j) {
                                            return function (k) {
                                                return function (l) {
                                                    return function (m) {
                                                        return function (n) {
                                                            return function (o) {
                                                                return fun(new Tuple15(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o));
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry14 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return function (j) {
                                            return function (k) {
                                                return function (l) {
                                                    return function (m) {
                                                        return function (n) {
                                                            return fun(new Tuple14(a, b, c, d, e, f, g, h, i, j, k, l, m, n));
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry13 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return function (j) {
                                            return function (k) {
                                                return function (l) {
                                                    return function (m) {
                                                        return fun(new Tuple13(a, b, c, d, e, f, g, h, i, j, k, l, m));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry12 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return function (j) {
                                            return function (k) {
                                                return function (l) {
                                                    return fun(new Tuple12(a, b, c, d, e, f, g, h, i, j, k, l));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry11 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return function (j) {
                                            return function (k) {
                                                return fun(new Tuple11(a, b, c, d, e, f, g, h, i, j, k));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry10 = function (fun) {
    return function (a) {
        return function (b) {
            return function (c) {
                return function (d) {
                    return function (e) {
                        return function (f) {
                            return function (g) {
                                return function (h) {
                                    return function (i) {
                                        return function (j) {
                                            return fun(new Tuple10(a, b, c, d, e, f, g, h, i, j));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var curry1 = function (fun) {
    return function (a) {
        return fun(a);
    };
};
module.exports = {
    Tuple0: Tuple0,
    Tuple1: Tuple1,
    unTuple1: unTuple1,
    uncurry1: uncurry1,
    curry1: curry1,
    Tuple2: Tuple2,
    uncurry2: uncurry2,
    curry2: curry2,
    Tuple3: Tuple3,
    uncurry3: uncurry3,
    curry3: curry3,
    Tuple4: Tuple4,
    uncurry4: uncurry4,
    curry4: curry4,
    Tuple5: Tuple5,
    uncurry5: uncurry5,
    curry5: curry5,
    Tuple6: Tuple6,
    uncurry6: uncurry6,
    curry6: curry6,
    Tuple7: Tuple7,
    uncurry7: uncurry7,
    curry7: curry7,
    Tuple8: Tuple8,
    uncurry8: uncurry8,
    curry8: curry8,
    Tuple9: Tuple9,
    uncurry9: uncurry9,
    curry9: curry9,
    Tuple10: Tuple10,
    uncurry10: uncurry10,
    curry10: curry10,
    Tuple11: Tuple11,
    uncurry11: uncurry11,
    curry11: curry11,
    Tuple12: Tuple12,
    uncurry12: uncurry12,
    curry12: curry12,
    Tuple13: Tuple13,
    uncurry13: uncurry13,
    curry13: curry13,
    Tuple14: Tuple14,
    uncurry14: uncurry14,
    curry14: curry14,
    Tuple15: Tuple15,
    uncurry15: uncurry15,
    curry15: curry15,
    Tuple16: Tuple16,
    uncurry16: uncurry16,
    curry16: curry16,
    genericTuple0: genericTuple0,
    showTupleO: showTupleO,
    eqTuple0: eqTuple0,
    genericTuple1: genericTuple1,
    showTuple1: showTuple1,
    eqTuple1: eqTuple1,
    genericTuple2: genericTuple2,
    showTuple2: showTuple2,
    eqTuple2: eqTuple2,
    genericTuple3: genericTuple3,
    showTuple3: showTuple3,
    eqTuple3: eqTuple3,
    genericTuple4: genericTuple4,
    showTuple4: showTuple4,
    eqTuple4: eqTuple4,
    genericTuple5: genericTuple5,
    showTuple5: showTuple5,
    eqTuple5: eqTuple5,
    genericTuple6: genericTuple6,
    showTuple6: showTuple6,
    eqTuple6: eqTuple6,
    genericTuple7: genericTuple7,
    showTuple7: showTuple7,
    eqTuple7: eqTuple7,
    genericTuple8: genericTuple8,
    showTuple8: showTuple8,
    eqTuple8: eqTuple8,
    genericTuple9: genericTuple9,
    showTuple9: showTuple9,
    eqTuple9: eqTuple9,
    genericTuple10: genericTuple10,
    showTuple10: showTuple10,
    eqTuple10: eqTuple10,
    genericTuple11: genericTuple11,
    showTuple11: showTuple11,
    eqTuple11: eqTuple11,
    genericTuple12: genericTuple12,
    showTuple12: showTuple12,
    eqTuple12: eqTuple12,
    genericTuple13: genericTuple13,
    showTuple13: showTuple13,
    eqTuple13: eqTuple13,
    genericTuple14: genericTuple14,
    showTuple14: showTuple14,
    eqTuple14: eqTuple14,
    genericTuple15: genericTuple15,
    showTuple15: showTuple15,
    eqTuple15: eqTuple15,
    genericTuple16: genericTuple16,
    showTuple16: showTuple16,
    eqTuple16: eqTuple16
};
